import React, { ReactNode } from "react";
import { Box, Paper, Typography } from "@mui/material";
import Button from "./Button";

interface Props {
  header?: string;
  content: ReactNode[];
  editFunction?: () => void;
  rows?: boolean;
}

const InfoBoxGroup: React.FC<Props> = (props) => {
  const { header, content, editFunction, rows } = props;

  return (
    <Paper
      sx={{
        padding: "20px",
        marginBottom: 5,
        overflow: "unset",
        boxSizing: "border-box",
      }}
    >
      {(!!header || !!editFunction) && (
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          marginBottom={3}
        >
          <Box display="flex" flexDirection="row" alignItems="center" gap={4}>
            {!!header && <Typography variant="h4">{header}</Typography>}
          </Box>
          <Box>
            {!!editFunction && (
              <Button
                label="Edit"
                variant="contained"
                color="info"
                onClick={editFunction}
              />
            )}
          </Box>
        </Box>
      )}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: rows ? "1fr" : "repeat(auto-fit, minmax(260px, 1fr))",
          },
          gap: "15px",
          width: "100%",
          alignItems: "stretch",
        }}
      >
        {content}
      </Box>
    </Paper>
  );
};

export default InfoBoxGroup;
